import React, { useContext } from 'react';
import {
  FormContext,
  FormInlineTableField,
  useEventCallback,
} from '@eas/common-web';
import { EsFileRegulation } from '@models';
import { RegulationEntityType, RegulationType } from '@enums';
import { useRegulationColumns } from './regulation-columns';
import { RegulationFieldProps } from './regulation-field';

type RegulationDialogProps = RegulationFieldProps & {
  disabledAdd: boolean;
};

export function RegulationDialog(
  props: RegulationDialogProps & { disabled: boolean }
) {
  const { setFieldValue, getFieldValues } = useContext(FormContext);
  const collectionDatakey = 'regulations';

  const handleRegulationTypeChange = useEventCallback((index: number) => {
    const fieldName = `${collectionDatakey}[${index}]`;
    const regulations = getFieldValues().regulations;

    if (regulations[index].regulationType === RegulationType.OTHER) {
      setFieldValue(`${fieldName}.type`, RegulationEntityType.PARAGRAPH);
    } else {
      setFieldValue(`${fieldName}.type`, RegulationEntityType.ARTICLE);
    }
  });

  const columns = useRegulationColumns(
    !!props.disabledAdd,
    handleRegulationTypeChange,
    collectionDatakey,
    props
  );

  return (
    <>
      <FormInlineTableField
        columns={columns}
        showToolbar={!props.disabledAdd}
        withRemove={!props.disabledAdd}
        disabledAdd={props.disabledAdd}
        name={collectionDatakey}
        labelOptions={{
          hide: true,
        }}
        initNewItem={() =>
          ({
            regulationType:
              RegulationType.CONSTITUTIONAL_LAWS_AND_INTERNATIONAL_TREATIES,
            type: RegulationEntityType.ARTICLE,
          } as EsFileRegulation)
        }
        maxRows={15}
        showDetailBtnCond={() => false}
      />
    </>
  );
}
